import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import theme from './theme';
import './styles/main.css';
import './i18n/config'; // Initialize i18n
import { HashRouter } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { initSentry } from './services/SentryService';
import analyticsService from './services/AnalyticsService';
import firebaseMessagingService from './services/FirebaseMessagingService';

// Initialize Sentry before React renders
initSentry();

// Initialize Analytics (web-only)
analyticsService.initialize();

// Initialize Firebase Cloud Messaging (push notifications)
firebaseMessagingService.initialize();

// Initialize PixiJS DevTools global (will be populated by GameTable)
if (typeof window !== 'undefined') {
  window.__PIXI_DEVTOOLS__ = {};
}

// Start the React app
const startApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HashRouter>
          <App />
        </HashRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
};

// Check if running on a native platform (Capacitor)
if (Capacitor.isNativePlatform()) {
  // Wait for Capacitor to be ready on native platforms
  document.addEventListener('DOMContentLoaded', startApp);
} else {
  // For web/development, start immediately
  startApp();
}
